import { Component, ChangeDetectionStrategy, Input, ContentChildren } from '@angular/core';
import { NglBreadcrumb } from './breadcrumb';
var NglBreadcrumbs = (function () {
    function NglBreadcrumbs() {
    }
    NglBreadcrumbs.decorators = [
        { type: Component, args: [{
                    selector: 'ngl-breadcrumbs',
                    template: "\n   <nav role=\"navigation\" [attr.aria-label]=\"assistiveText\"><ol class=\"slds-breadcrumb slds-list--horizontal\"><li class=\"slds-breadcrumb__item\" *ngFor=\"let b of breadcrumbs\"><ng-template [ngTemplateOutlet]=\"b.templateRef\"></ng-template></li></ol></nav>\n ",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                },] },
    ];
    /** @nocollapse */
    NglBreadcrumbs.ctorParameters = function () { return []; };
    NglBreadcrumbs.propDecorators = {
        'assistiveText': [{ type: Input },],
        'breadcrumbs': [{ type: ContentChildren, args: [NglBreadcrumb,] },],
    };
    return NglBreadcrumbs;
}());
export { NglBreadcrumbs };
//# sourceMappingURL=breadcrumbs.js.map